export default __webpack_public_path__ + "static/media/medium.e31dc18b.png";